import React from "react";
import GemeindeContainer from "../../components/gemeinde/gemeinde.container";
import PageHeaderComponent from "../../components/page-components/page-header.component";

class GemeindePage extends React.Component {
  render() {
    return (
      <div>
        <PageHeaderComponent
          title="Meine Gemeinde"
          subtitle="Wo ich mich zuhause fühle..."
        />
        <GemeindeContainer />
      </div>
    );
  }
}

export default GemeindePage;
